import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../Styles/Components.less";
import MainPage from "./MainPage";

class HelpPage extends React.Component {
  render() {
    return (
      <MainPage>
        <div className="help-container">
          <div className="box-container">
            <div className="version-container">
              <div>Operations Portal: 1.7.9</div>
              {/* <div>Device Management Version : 1.8.7</div> */}
            </div>
          </div>
        </div>
      </MainPage>
    );
  }
}

HelpPage.propTypes = {};

const mapStateToProps = (state) => ({});
const connectedHelpPage = connect(mapStateToProps)(HelpPage);
export default withRouter(connectedHelpPage);
